<template>
  <v-main>
    <v-container class="fill-height" fluid style="background-color: #ccc">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-row align="center" justify="center">
            <v-col cols="12" align="center">
              <div style="font-size: 28px">ลงทะเบียนใช้งาน</div>
            </v-col>
          </v-row>
          <v-card class="elevation-12" v-if="!$store.getters.isAuthen || true">
            <v-toolbar color="primary" dark flat v-if="false">
              <v-toolbar-title>SignIn </v-toolbar-title>
              <v-spacer />
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :href="source"
                    icon
                    large
                    target="_blank"
                    v-on="on"
                  >
                    <v-icon>mdi-code-tags</v-icon>
                  </v-btn>
                </template>
                <span>Source</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    large
                    href="https://codepen.io/johnjleider/pen/pMvGQO"
                    target="_blank"
                    v-on="on"
                  >
                    <v-icon>mdi-codepen</v-icon>
                  </v-btn>
                </template>
                <span>Codepen</span>
              </v-tooltip> -->
            </v-toolbar>
            <v-card-text>
              <div align="center">
                <!-- <v-avatar size="120px"> -->
                <img height="60" :src="staticPath + 'logo_tai.jpg'" />
                <!-- <br/><br/> -->
                <!-- <p>โปรดกรอก ชื่อผู้ใช้ และ รหัสผ่าน<br> -->
                <!-- <span style="font-size:12px;color:#252525">(โดยใช้ชุดเดียวกันกับตอนล็อกอินบนเครื่องคอมพิวเตอร์ที่<br>สถาบันยานยนต์)</span> -->
                <!-- </p> -->
                <!-- </v-avatar> -->
              </div>
              <v-form v-model="valid" ref="form" @submit.prevent="onSubmit">
                <v-text-field ref="username" label="กรุณากรอก Email" prepend-inner-icon="mdi-account" class="my-5" hint="" v-model="user.username" :rules="nameRules" @keyup.enter="Register()" autofocus required :disabled="loading"></v-text-field>
              </v-form>
              <v-alert v-if="error !== ''" outline color="error" icon="warning" :value="true">
                {{ error }}
              </v-alert>
              <v-alert type="warning" :value="$browserDetect.isIE"> กรุณาเปิดด้วย Chrome หรือ Firefox หรือ Safari </v-alert>
            </v-card-text>
            <v-progress-linear v-bind:indeterminate="true" v-if="loading"></v-progress-linear>
            <!-- <v-card-actions> -->
            <!-- <v-spacer /> -->
            <!-- <v-btn color="primary" @click="authen">Login</v-btn> -->
            <!-- <v-btn @click="clear">clear</v-btn> -->
            <!-- </v-card-actions> -->
            <v-card-actions class="text-center">
              <v-row no-gutters align="center" justify="center">
                <v-col cols="12" sm="12" md="12" align="center" justify="center">
                  <h6 class="red--text">** ระบบจะสร้าง password และส่งกลับไปทางอีเมล์ที่ผู้สมัครได้ระบุไว้ ภายใน 5-10 นาที หากไม่พบอีเมล์ตอบกลับโปรดตรวจสอบใน Junk mail และหลังจากนั้นท่านสามารถ login และแก้ไข password ได้ด้วยตนเอง</h6>
                </v-col>
                <v-col cols="12" class="my-2" align="center" justify="center">
                  <v-spacer></v-spacer>
                  <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey"> </vue-recaptcha>
                  <v-spacer></v-spacer>
                </v-col>
                <v-col cols="12" align="center" justify="center" class="my-4">
                  <v-btn text color="error" @click="dialog_consent = true">เงื่อนไขการสมัครใช้งาน</v-btn>
                </v-col>
                <v-col cols="12" align="center" justify="center" class="my-4">
                  <v-btn v-if="consent" block my-5 @click="Register" :disabled="loading" :class="{ primary: valid, error: !valid }">ลงทะเบียน</v-btn>
                </v-col>
              </v-row>
              <!-- <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" size="invisible" :sitekey="sitekey"> </vue-recaptcha> -->
            </v-card-actions>
          </v-card>

          <v-card class="my-5">
            <v-card-actions>
              <v-btn text block class="blue--text" @click="signIn">กลับไปหน้าเข้าสู่ระบบ</v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-alert color="error" class="white--text">{{$browserDetect}}หมายเหตุ : กรุณากด Ctrl+F5 เพื่อรับ Version ใหม่ของโปรแกรม</v-alert> -->

          <v-card v-if="$store.getters.isAuthen && false">
            <v-toolbar class="primary" dark dense flat>
              <v-toolbar-title>ลงชื่อออกจากระบบ</v-toolbar-title>
            </v-toolbar>
            <v-img :src="$store.state.rootPath + 'static/Logo_TAI.jpg'" height="90px" contain> </v-img>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $store.state.users.main.FullName }}
                </h3>
                <div>{{ $store.state.users.main.Department }}<br />{{ $store.state.users.main.Division }}</div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn text class="blue--text" @click="signOut">signOut</v-btn>
            </v-card-actions>
          </v-card>
          <br /><br />
          <div style="font-size: 14px" class="lockscreen-footer text-center">Ver:1.20.0 Build:20240307.015017</div>
          <div class="lockscreen-footer text-center">
            Copyright © 2023
            <b><a href="#" class="text-black"></a></b><br />
            All rights reserved
          </div>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog_consent" width="80%">
        <v-card>
          <v-card-title>
            <span class="text-h5">ประกาศเกี่ยวกับความเป็นส่วนตัวของผู้ใช้บริการ</span>
          </v-card-title>
          <v-card-text>
            <object data="https://thaiauto.or.th/2020/th/about-us/download/SD06.pdf" type="application/pdf" width="100%" height="500px">
              <p>Unable to display PDF file. <a href="https://thaiauto.or.th/2020/th/about-us/download/SD06.pdf">Download</a> instead.</p>
            </object>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="
                dialog_consent = false
                consent = false
              "
            >
              ไม่ยอมรับ
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                dialog_consent = false
                consent = true
              "
            >
              ยอมรับ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="showUpdate" timeout="3000" top @input="snackInput">
        {{ showText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="showUpdate = false"> ปิด </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { mapActions } from 'vuex'
import itemServe from '@/store/api/services/customersService'
// import browserDetect from 'vue-browser-detect-plugin'

export default {
  name: 'login',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      dialog_consent: false,
      consent: false,
      emailReady: false,
      sitekey: '6LfRYwAgAAAAAGvIRAzdtN823T4sdbvJLzgHj_8D',
      recapcha: '',
      showUpdate: false,
      showText: '',
      showpass: false,
      version: '1.20.0',
      apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      staticPath: process.env.VUE_APP_STATIC.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      user: {
        username: '',
        password: '',
        version: '1.20.0'
      },
      redirect: '',
      valid: false,
      loading: false,
      error: '',
      browser: '',

      // nameRules: [(v) => !!v || 'กรุณาใส่ UserName', (v) => v.length >= 5 || 'ชื่อต้องไม่น้อยกว่า 5 ตัวอักษร'],
      passwordRules: [(v) => !!v || 'กรุณาใส่ Password', (v) => v.length >= 6 || 'ชื่อต้องไม่น้อยกว่า 6 ตัวอักษร'],
      nameRules: [
        (val) => {
          // email check
          const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return patternEmail.test(val) || 'Invalid e-mail.'
        },
        (val) => this.recapcha !== '' || 'reCAPTCHA is required.' + this.recapcha
      ]
    }
  },

  mounted() {
    // browser = $browserDetect
    console.log('browser', this.browser)
    console.log('process.env', process.env)
    window.localStorage.clear()
    localStorage.setItem('isoList-pagination', '')
    localStorage.setItem('isoList-process', '')
    localStorage.setItem('isoList-filter', '')
    localStorage.setItem('vuex', '')
    localStorage.setItem('EmpAll', '')
  },
  methods: {
    ...mapActions(['signIn']),
    snackInput() {
      if (this.redirect !== '') {
        this.$router.push(this.redirect)
      }
    },
    clear() {
      this.user.username = ''
      this.user.password = ''
      this.loading = false
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.signIn()
      }
    },
    async signIn() {
      console.log('singIn')
      this.$router.push('/signin')
    },
    signOut() {
      this.$store.dispatch('signOut')
      this.$router.push('/signin')
    },
    async Register() {
      if (this.valid) {
        console.log('Register')
        this.loading = true
        this.error = ''

        this.redirect = ''
        let response = await itemServe.register(this.user)
        this.emailReady = false
        console.log('usersEdit Save Update then')
        if (response.error === '') {
          console.log('usersEdit Save Update then OK')
          // this.itemSelected = response.data.data[0]
          // let itemSelected_update = response.data.data[0] // this.itemSelected
          this.$emit('update', this.user)
          this.loading = false
          this.consent = false
          this.user.username = ''
          this.showText = 'ลงทะเบียนสำเร็จโปรดตรวจสอบ Email ของท่าน'
          this.showUpdate = true
          this.redirect = '/signin'
          // this.$router.push(this.redirect)
          return true
        } else {
          this.loading = false
          console.log('usersEdit Save Update then error')
          // alert('!!เกิดข้อผิดพลาด\n' + response.error)
          if (response.error === 'Email is already Exist') {
            this.showText = 'อีมเล์นี้ลงทะเบียนแล้ว'
            this.emailReady = true
          }

          this.showUpdate = true
          this.redirect = ''
          this.resetRecaptcha()
          return false
        }
      }
    },
    onSubmit: function () {
      this.$refs.recaptcha.execute()
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.recapcha = response
      this.$refs.form.validate()
    },
    onExpired: function () {
      console.log('Expired')
      this.recapcha = ''
      this.$refs.form.validate()
    },
    resetRecaptcha() {
      this.recapcha = ''
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  }
}
</script>

<style scoped>
OL {
  margin-top: 10px;
  counter-reset: item;
}
LI {
  margin-top: 10px;
  display: block;
}
LI:before {
  content: counters(item, '.') ' ';
  counter-increment: item;
}
</style>
